import { ItemFormPopup } from '#components/Map/Subcomponents/ItemFormPopup'

/**
 * @category Item
 */
export const PopupForm = ({ children }: { children?: React.ReactNode }) => {
  return <ItemFormPopup>{children}</ItemFormPopup>
}
